import { IProduct } from "../types/product.type";

export const getWarehouseCount = (warehouse: IProduct) => {
  return warehouse.batches.reduce((acc, currentValue) => {
    return (acc += currentValue.batchQuantity);
  }, 0);
};
